import store from "../../store"

const GetUserDetailsAction = () => {
    return store.getState().userDetails.value
}
export default GetUserDetailsAction